<div
  [ngClass]="errorMessage ? '' : 'ti-hidden'"
  appScrollToEvent
  appScrollToChangedPreviouslyElement
  [shouldBeEmittedScrollToTopEventEvent]="shouldBeEmittedScrollToTopEventEvent"
>
  <p>{{errorMessage}}</p>
  <mat-icon *ngIf="!hideCloseSign" (click)="clear()" aria-hidden="true">clear</mat-icon>
</div>
